module.exports = __webpack_public_path__ + "static/SectionFiveBackground.750ce128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pngs/SectionFiveBackground.png
// module id = 497
// module chunks = 35783957827783